var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronTop = function SvgChevronTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E201D",
    d: "M21 15.75c0-.32-.126-.64-.377-.884l-7.714-7.5a1.31 1.31 0 0 0-1.818 0l-7.714 7.5a1.225 1.225 0 0 0 0 1.767 1.31 1.31 0 0 0 1.818 0L12 10.017l6.806 6.617a1.31 1.31 0 0 0 1.818 0c.251-.244.376-.565.376-.885"
  })));
};
export default SvgChevronTop;